import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const paperWrapper = css`
  && {
    overflow-x: hidden;
    border-top: 0;
  }
`;

const modalWidth = 720;
export const modalContent = css`
  width: ${modalWidth}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
`;

export const title = css`
  text-align: center;
  left: -100px;
  margin: 30px 40px 0;
  line-height: 23px;
  letter-spacing: normal;
  color: ${colors.black};
  font-weight: ${fonts.weight.medium};
  font-size: ${fonts.size.large};
`;

export const info = css`
  height: 38px;
  line-height: 19px;
  text-align: center;
  letter-spacing: normal;
  margin: 20px 40px 40px;
  color: ${colors.black};
  font-weight: ${fonts.weight.light};
  font-size: ${fonts.size.small};
`;

export const action = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  & > *:not(:last-child) {
    margin-right: 30px;
  }
`;
